export default __webpack_public_path__ + "static/media/increaseFS.e7de6e72.svg";